import type { RouteObject } from 'react-router-dom';

import Index from '@pages/Index/Index.loadable';
import PublicationGet from '@pages/PublicationGet/PublicationGet.loadable';
import PublicationNew from '@pages/PublicationNew/PublicationNew.loadable';
import PublicationEdit from '@pages/PublicationEdit/PublicationEdit.loadable';
import User from '@pages/User/User.loadable';
import AccountEdit from '@pages/AccountEdit/AccountEdit.loadable';
import Account from '@pages/Account/Account.loadable';
import Likes from '@pages/Likes/Likes.loadable';
import Notify from '@pages/Notify/Notify.loadable';

export const routes: RouteObject[] = [
    {
        path: '/',
        Component: Index,
    },
    {
        path: '/publication/:id',
        Component: PublicationGet,
    },
    {
        path: '/publication/new',
        Component: PublicationNew,
    },
    {
        path: '/publication/:id/edit',
        Component: PublicationEdit,
    },
    {
        path: '/user/:id',
        Component: User,
    },
    {
        path: '/account/edit',
        Component: AccountEdit,
    },
    {
        path: '/account',
        Component: Account,
    },
    {
        path: '/likes',
        Component: Likes,
    },
    {
        path: '/notify',
        Component: Notify,
    },
];
